import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetProductService } from '../../services/asset-product-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-category-entity';


@Component({
    selector: 'asset-product-category-list',
    templateUrl: './asset-product-category-list.component.html',
    styleUrls: ['./asset-product-category-list.component.scss']
})


export class AssetProductCategoryListComponent extends BasePage2<AssetProductCategory> {

    assetProductCategories   : AssetProductCategory[] = [];
    code                : string;
    name                : string;

    constructor(
        protected toastr        : ToastrService,
        protected assetProductService: AssetProductService,
        protected router        : Router,
        protected baseService   : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location      : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'assetProductCategory';
    }


    listFields = [
        { prop: 'rank',                     name: 'Rank',  type : "number" },
        { prop: 'assetProductCategoryCode', name: 'Code',  insertOnly : true},
        { prop: 'name',                     name: 'Name' },
    ]


// ---------------------------------------------------------------------
    ngAfterViewInit(){
        super.ngAfterViewInit();
        this.loadData();
    }
// ---------------------------------------------------------------------


// ---------------------------------------------------------------------
    getRows(): AssetProductCategory[] {
        return this.assetProductCategories;
    }
// ---------------------------------------------------------------------


// ---------------------------------------------------
    saveRow(row: AssetProductCategory): Promise<AssetProductCategory> {
        return this.assetProductService.assetProductCategorySave(row);
    }
// ---------------------------------------------------

//----------------------------------------------------------------------
new(){
    let entity : AssetProductCategory = new AssetProductCategory();
    entity.inserted = true;
    entity.edit = true;
    this.assetProductCategories.push(entity);
    this.assetProductCategories = [...this.assetProductCategories];
  }
//----------------------------------------------------------------------


// ---------------------------------------------------
loadData() {
        this.assetProductService.assetProductCategoriesGet(this.code).then(result => {
            this.assetProductCategories = result;
            
        })
    }
// ---------------------------------------------------

}
